var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable brace-style, comma-dangle, no-unused-vars, no-var, react/forbid-prop-types, react/jsx-closing-bracket-location, react/jsx-indent-props, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

/**
 * This is an example graphie-using widget
 *
 * TODO(jack): Add more comments
 */

var React = require("react");
var _ = require("underscore");

var ApiOptions = require("../perseus-api.jsx").Options;
var Util = require("../util.js");
var Changeable = require("../mixins/changeable.jsx");
var WidgetJsonifyDeprecated = require("../mixins/widget-jsonify-deprecated.jsx");

var Graphie = require("../components/graphie.jsx");
var MovablePoint = Graphie.MovablePoint;

var knumber = require("kmath").number;
var kpoint = require("kmath").point;

/**
 * This is the widget's renderer. It shows up in the right column
 * in the demo, and is what is visible to users, and where
 * users enter their answers.
 */
var ExampleGraphieWidget = React.createClass({
    displayName: "ExampleGraphieWidget",

    propTypes: _extends({}, Changeable.propTypes, {
        apiOptions: ApiOptions.propTypes,

        graph: React.PropTypes.object.isRequired,
        coord: React.PropTypes.arrayOf(React.PropTypes.number)
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            // We want to allow our coord to be null to test if the
            // user has interacted with this widget yet when grading it
            coord: null,
            graph: {
                box: [400, 400],
                labels: ["x", "y"],
                range: [[-10, 10], [-10, 10]],
                step: [1, 1],
                gridStep: [1, 1],
                valid: true,
                backgroundImage: null,
                markings: "grid",
                showProtractor: false
            }
        };
    },

    getUserInput: function getUserInput() {
        return WidgetJsonifyDeprecated.getUserInput.call(this);
    },

    render: function render() {
        return React.createElement(
            Graphie,
            {
                ref: "graphie",
                box: this.props.graph.box,
                range: this.props.graph.range,
                options: this.props.graph,
                setup: this.setupGraphie,
                setDrawingAreaAvailable: this.props.apiOptions.setDrawingAreaAvailable
            },
            React.createElement(MovablePoint, {
                pointSize: 5,
                coord: this.props.coord || [0, 0],
                constraints: [MovablePoint.constraints.snap(), MovablePoint.constraints.bound()],
                onMove: this.movePoint
            })
        );
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    movePoint: function movePoint(newCoord) {
        this.change({
            coord: newCoord
        });
    },

    _getGridConfig: function _getGridConfig(options) {
        return _.map(options.step, function (step, i) {
            return Util.gridDimensionConfig(step, options.range[i], options.box[i], options.gridStep[i]);
        });
    },

    setupGraphie: function setupGraphie(graphie, options) {
        var gridConfig = this._getGridConfig(options);
        graphie.graphInit({
            range: options.range,
            scale: _.pluck(gridConfig, "scale"),
            axisArrows: "<->",
            labelFormat: function labelFormat(s) {
                return "\\small{" + s + "}";
            },
            gridStep: options.gridStep,
            tickStep: _.pluck(gridConfig, "tickStep"),
            labelStep: 1,
            unityLabels: _.pluck(gridConfig, "unityLabel")
        });
        graphie.label([0, options.range[1][1]], options.labels[1], "above");
    },

    simpleValidate: function simpleValidate(rubric) {
        return ExampleGraphieWidget.validate(this.getUserInput(), rubric);
    }
});

/**
 * This is the widget's grading function
 */
_.extend(ExampleGraphieWidget, {
    validate: function validate(state, rubric) {
        if (state.coord == null) {
            return {
                type: "invalid",
                message: null
            };
        } else if (kpoint.equal(state.coord, rubric.correct)) {
            return {
                type: "points",
                earned: 1,
                total: 1,
                message: null
            };
        } else {
            return {
                type: "points",
                earned: 0,
                total: 1,
                message: null
            };
        }
    }
});

/**
 * For this widget to work, we must export it.
 * We also must require() this file in src/all-widgets.js
 */
module.exports = {
    name: "example-graphie-widget",
    displayName: "Example Graphie Widget",
    hidden: true, // Hides this widget from the Perseus.Editor widget select
    widget: ExampleGraphieWidget
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/example-graphie-widget.jsx
 ** module id = 158
 ** module chunks = 0 1
 **/